import type {
  AgentProfileEditRequestDto,
  AgentProfileResponseDto,
} from '@shared/services/apiService';

/** Exact source taxonomy; persisted metadata, independent from instructions and workflow. */
export const jobSectors = [
  { id: 'medical', label: 'Medical & healthcare' },
  { id: 'hospitality', label: 'Hospitality' },
  { id: 'real-estate', label: 'Real estate' },
  { id: 'retail', label: 'Retail & e-commerce' },
  { id: 'professional-services', label: 'Professional services' },
  { id: 'general', label: 'General' },
] as const;
export type JobSectorId = (typeof jobSectors)[number]['id'];
export type WorkspaceJobMetadata = { sector?: JobSectorId | null; summary?: string | null };
export type WorkspaceJobProfile = AgentProfileResponseDto & WorkspaceJobMetadata;
export type WorkspaceJobPatch = AgentProfileEditRequestDto & WorkspaceJobMetadata;
export const jobSectorLabel = (value: string | null | undefined) =>
  jobSectors.find((sector) => sector.id === value)?.label ?? 'Unspecified';

/** Omission preserves pre-feature data; null is an intentional clear. */
export const jobMetadata = (profile: WorkspaceJobMetadata): WorkspaceJobMetadata => ({
  ...(profile.sector !== undefined ? { sector: profile.sector } : {}),
  ...(profile.summary !== undefined ? { summary: profile.summary } : {}),
});
